export const DBConfig = {
    name: 'MyDB',
    version: 1,
    objectStoresMeta: [
        {
            store: 'sfrid',
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
                { name: 'sfrid', keypath: 'sfrid', options: { unique: false } },
                { name: 'active', keypath: 'active', options: { unique: false } },
                { name: 'app', keypath: 'app', options: { unique: false } },
                { name: 'attitude', keypath: 'attitude', options: { unique: false } },
                { name: 'cal', keypath: 'cal', options: { unique: false } },
                { name: 'category', keypath: 'category', options: { unique: false } },
                { name: 'clentsid', keypath: 'clentsid', options: { unique: false } },
                { name: 'clientname', keypath: 'clientname', options: { unique: false } },
                { name: 'com', keypath: 'com', options: { unique: false } },
                { name: 'date', keypath: 'date', options: { unique: false } },
                { name: 'fleetsid', keypath: 'fleetsid', options: { unique: false } },
                { name: 'fpa', keypath: 'fpa', options: { unique: false } },
                { name: 'fpm', keypath: 'fpm', options: { unique: false } },
                { name: 'knowledge', keypath: 'knowledge', options: { unique: false } },
                { name: 'ltw', keypath: 'ltw', options: { unique: false } },
                { name: 'minutes', keypath: 'minutes', options: { unique: false } },
                { name: 'ntc', keypath: 'ntc', options: { unique: false } },
                { name: 'pdm', keypath: 'pdm', options: { unique: false } },
                { name: 'preview', keypath: 'preview', options: { unique: false } },
                { name: 'published', keypath: 'published', options: { unique: false } },
                { name: 'reginfo', keypath: 'reginfo', options: { unique: false } },
                { name: 'remarks', keypath: 'remarks', options: { unique: false } },
                { name: 'remarkstext', keypath: 'remarkstext', options: { unique: false } },
                { name: 'result', keypath: 'result', options: { unique: false } },
                { name: 'resulttext', keypath: 'resulttext', options: { unique: false } },
                { name: 'saw', keypath: 'saw', options: { unique: false } },
                { name: 'sid', keypath: 'sid', options: { unique: false } },
                { name: 'simformid', keypath: 'simformid', options: { unique: false } },
                { name: 'simformname', keypath: 'simformname', options: { unique: false } },
                { name: 'simlocation', keypath: 'simlocation', options: { unique: false } },
                { name: 'simrecord', keypath: 'simrecord', options: { unique: false } },
                { name: 'simtype', keypath: 'simtype', options: { unique: false } },
                { name: 'simreg', keypath: 'simreg', options: { unique: false } },
                { name: 'stage', keypath: 'stage', options: { unique: false } },
                { name: 'skil', keypath: 'skil', options: { unique: false } },
                { name: 'subcategory', keypath: 'subcategory', options: { unique: false } },
                { name: 'tc', keypath: 'tc', options: { unique: false } },
                { name: 'tkn', keypath: 'tkn', options: { unique: false } },
                { name: 'traineeecode', keypath: 'traineeecode', options: { unique: false } },
                { name: 'traineeid', keypath: 'traineeid', options: { unique: false } },
                { name: 'traineelicence', keypath: 'traineelicence', options: { unique: false } },
                { name: 'traineename', keypath: 'traineename', options: { unique: false } },
                { name: 'traineerank', keypath: 'traineerank', options: { unique: false } },
                { name: 'traineerankid', keypath: 'traineerankid', options: { unique: false } },
                { name: 'traineesign', keypath: 'traineesign', options: { unique: false } },
                { name: 'trainerecode', keypath: 'trainerecode', options: { unique: false } },
                { name: 'trainerid', keypath: 'trainerid', options: { unique: false } },
                { name: 'trainerlicense', keypath: 'trainerlicense', options: { unique: false } },
                { name: 'trainername', keypath: 'trainername', options: { unique: false } },
                { name: 'trainerrank', keypath: 'trainerrank', options: { unique: false } },
                { name: 'trainerrankid', keypath: 'trainerrankid', options: { unique: false } },
                { name: 'trainersign', keypath: 'trainersign', options: { unique: false } },
                { name: 'validity', keypath: 'validity', options: { unique: false } },
                { name: 'validtill', keypath: 'validtill', options: { unique: false } },
                { name: 'wlm', keypath: 'wlm', options: { unique: false } },
                { name: 'manageremail', keypath: 'manageremail', options: { unique: false } },
                { name: 'timestamp', keypath: 'timestamp', options: { unique: false } }
            ]
        },
        {
            store: "stcid",
            storeConfig: { keyPath: 'id', autoIncrement: true },
            storeSchema: [
                { name: 'sfrid', keypath: 'sfrid', options: { unique: false } },
                { name: 'stcrid', keypath: 'stcrid', options: { unique: false } },
                { name: 'active', keypath: 'active', options: { unique: false } },
                { name: 'ata', keypath: 'ata', options: { unique: false } },
                { name: 'clientname', keypath: 'clientname', options: { unique: false } },
                { name: 'clientsid', keypath: 'clientsid', options: { unique: false } },
                { name: 'fleetsid', keypath: 'fleetsid', options: { unique: false } },
                { name: 'null', keypath: 'null', options: { unique: false } },
                { name: 'patch', keypath: 'patch', options: { unique: false } },
                { name: 'phase', keypath: 'phase', options: { unique: false } },
                { name: 'published', keypath: 'published', options: { unique: false } },
                { name: 'score', keypath: 'score', options: { unique: false } },
                { name: 'sequence', keypath: 'sequence', options: { unique: false } },
                { name: 'simformid', keypath: 'simformid', options: { unique: false } },
                { name: 'sits', keypath: 'sits', options: { unique: false } },
                { name: 'stcid', keypath: 'stcid', options: { unique: false } },
                { name: 'stcname', keypath: 'stcname', options: { unique: false } },
                { name: 'stcshortname', keypath: 'stcshortname', options: { unique: false } },
                { name: 'traineeid', keypath: 'traineeid', options: { unique: false } },
                { name: 'trainerid', keypath: 'trainerid', options: { unique: false } },
            ]
        }
    ]
};